import axios from 'axios';

import Config from './Config';
import { getUserToken } from './utils/token-utils';

const apiRoot = Config.get('api-gw');

export const Images = {
    getUploadUrl: (type: string, extension: string) =>
        axios.post(`${apiRoot}v2/images/presigned-url`, 
            { type, extension },
            { headers: { token: getUserToken() }}),
    uploadImageToS3: async (blob: Blob, uploadUrl: string) => {
        await axios.put(uploadUrl, blob, {
            headers: {
                'Content-Type': blob.type, // e.g. 'image/png'
            },
        });
    }
};